<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_406_2515)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.07607 4.18824C6.07645 4.57634 5.76145 4.89096 5.37296 4.89096C4.98444 4.89096 4.66986 4.57638 4.66986 4.18786V1.12107C4.66986 0.732591 4.98483 0.417969 5.37296 0.417969C5.7611 0.417969 6.07607 0.732591 6.07607 1.12107V4.18824ZM19.2924 2.0329H16.7127C16.3243 2.0329 16.0093 2.34752 16.0093 2.736C16.0093 3.12448 16.3242 3.43911 16.7127 3.43911H18.5897V18.1778H1.40617V3.43911H3.42441C3.8125 3.43911 4.12751 3.12448 4.12751 2.736C4.12751 2.34752 3.81289 2.0329 3.42441 2.0329H0.703061C0.314966 2.0329 0 2.34752 0 2.736V18.8808C0 19.2689 0.314966 19.5835 0.703104 19.5835H19.2928C19.6812 19.5835 19.9959 19.2689 19.9955 18.8808V2.736C19.9955 2.34752 19.6809 2.0329 19.2924 2.0329ZM7.30174 3.43911H12.7871C13.1756 3.43911 13.4906 3.12448 13.4906 2.736C13.4906 2.34752 13.1756 2.0329 12.7871 2.0329H7.30174C6.91364 2.0329 6.59863 2.34752 6.59863 2.736C6.59863 3.12448 6.91325 3.43911 7.30174 3.43911ZM14.7493 4.89096C15.1374 4.89096 15.452 4.57634 15.4524 4.18824V1.12107C15.4524 0.732591 15.1378 0.417969 14.7493 0.417969C14.3608 0.417969 14.0458 0.732591 14.0458 1.12107V4.18786C14.0459 4.57638 14.3608 4.89096 14.7493 4.89096ZM15.5663 10.8078C15.5659 13.8781 13.0681 16.3751 9.99792 16.3751C6.92809 16.3751 4.4303 13.8777 4.4303 10.8078C4.4303 7.73802 6.92809 5.241 9.99792 5.241C13.0681 5.241 15.5663 7.7384 15.5663 10.8078ZM14.1593 10.8078C14.1593 8.51387 12.2923 6.64682 9.99792 6.64682C7.70355 6.64682 5.83689 8.51348 5.83689 10.8078C5.83689 13.1022 7.70355 14.9693 9.99792 14.9693C12.2927 14.9693 14.1593 13.1026 14.1593 10.8078ZM10.909 12.1138L11.4722 10.3805L9.99788 9.30872L8.52313 10.3805L9.08684 12.1138H10.909ZM11.2213 7.47517L11.3908 7.75777L9.99756 8.30393L8.60431 7.75777L8.77417 7.47517C9.1566 7.335 9.56753 7.255 9.99756 7.255C10.4283 7.255 10.8393 7.335 11.2213 7.47517ZM13.5366 11.2866C13.556 11.1354 13.5685 10.983 13.5685 10.8273C13.5685 10.1162 13.3587 9.45534 13.0011 8.89888L12.6872 8.79489L12.4587 10.2746L13.297 11.5135L13.5366 11.2866ZM10.5021 14.1591L11.3724 12.9415L12.8388 12.641L12.851 12.9693C12.3524 13.6301 11.6326 14.1123 10.7996 14.3042L10.5021 14.1591ZM7.15696 12.641L7.14594 12.9693C7.64411 13.6301 8.36395 14.1123 9.19692 14.3043L9.49438 14.1592L8.62407 12.9415L7.15696 12.641ZM6.99514 8.89853L7.30899 8.79416L7.53675 10.2739L6.69807 11.5128L6.45963 11.2855C6.44057 11.1347 6.42688 10.9827 6.42688 10.8269C6.42688 10.1158 6.63636 9.45499 6.99514 8.89853Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_406_2515">
        <rect width="20" height="20" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
</template>
<script setup lang="ts">
interface IProps {
  fill: string;
  fillReact: string;
}

const props = withDefaults(defineProps<IProps>(), {
  fill: "#9C9C9C",
  fillReact: "#FFFFFF"
});
</script>

<script lang="ts">
export default {};
</script>
